import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
// contexts
import { useAuth } from '../../../contexts/AuthContext';
// utils
import { ADMIN_ROLES } from '../../../utils/format';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { admin } = useAuth();

  const initials = (admin?.fullName || 'A')
    .split(' ')
    .slice(0, 2)
    .map((s) => s[0])
    .join('');

  return (
    <Link underline="none" color="inherit">
      <RootStyle sx={{ ...(isCollapse && { bgcolor: 'transparent' }) }}>
        <Avatar src={admin?.avatarUrl || undefined} sx={{ bgcolor: 'primary.main' }}>
          {initials}
        </Avatar>

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', { duration: theme.transitions.duration.shorter }),
            ...(isCollapse && { ml: 0, width: 0 }),
          }}
        >
          <Typography variant="subtitle2" noWrap>
            {admin?.fullName || '—'}
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {ADMIN_ROLES[admin?.role] || ''}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
